import { render, staticRenderFns } from "./AllocationProjectItem.vue?vue&type=template&id=4a6ce554&scoped=true"
import script from "./AllocationProjectItem.vue?vue&type=script&lang=ts"
export * from "./AllocationProjectItem.vue?vue&type=script&lang=ts"
import style0 from "./AllocationProjectItem.vue?vue&type=style&index=0&id=4a6ce554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6ce554",
  null
  
)

export default component.exports